import { mobileBreakpoint } from "../../lib/helper/viewportHelper"
import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(theme => ({
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3)
    },
    splashCard: {
        maxWidth: "100%"
    },
    splashMedia: {
        height: 0,
        paddingTop: "56.25%"
    },
    thumbnailStepper: {
        width: "100%",
        lg: 550,
        [theme.breakpoints.down(mobileBreakpoint)]: {
            minHeight: "auto"
        }
    }
}))
